import { render, staticRenderFns } from "./HolderForm.vue?vue&type=template&id=40fb2b0c&scoped=true&lang=html&"
import script from "./HolderForm.vue?vue&type=script&lang=js&"
export * from "./HolderForm.vue?vue&type=script&lang=js&"
import style0 from "./HolderForm.vue?vue&type=style&index=0&id=40fb2b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb2b0c",
  null
  
)

export default component.exports